export default __webpack_public_path__ + "static/media/stock.3d417026.svg";